import { render, staticRenderFns } from "./VRename.vue?vue&type=template&id=a2f15b04&"
import script from "./VRename.vue?vue&type=script&lang=ts&"
export * from "./VRename.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports